import type { Component, PageLayout } from '../../schemas/validation';
import type { PreviewData } from './types';

function hasVisiblePageBody(components: Component[]): boolean {
  return components.some(c => c.type !== 'head-content' && c.visible !== false);
}

function hasLayoutChrome(layout: PageLayout | null | undefined): boolean {
  const components = layout?.components;
  return Array.isArray(components) && components.length > 0;
}

/** True when preview should skip layout/page chrome and show the empty placeholder. */
export function shouldRenderEmptyPreview(previewData: PreviewData | null): boolean {
  if (!previewData) return true;
  if (hasLayoutChrome(previewData.layout)) return false;
  return !hasVisiblePageBody(previewData.components);
}
